import hooks from './shipment-stats.hooks';

export default (app) => {
  const service = app.service('api/shipment-stats');
  service.hooks(hooks);
};
